module.exports = __webpack_public_path__ + "static/img/promotion_login_bg.4b002b7a.png";